import FormattedList from 'I18n/components/FormattedList';
import { UnifiedRoutingActionExplainer } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingActionExplainer';
import { ROUTING_ROTATE_TICKET_OWNER } from 'automation-ui-action-features/constants/Gates';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import TeamName from 'automation-ui-references/customer-data/TeamName';
import UserName from 'automation-ui-references/customer-data/UserName';
import { TICKET_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RotateObjectActionExplainer({
  action,
  flowObjectTypeId
}) {
  const isUngatedToSVHTicketRouting = useIsUngated(ROUTING_ROTATE_TICKET_OWNER);
  if (flowObjectTypeId === TICKET_ID && isUngatedToSVHTicketRouting) {
    return /*#__PURE__*/_jsx(UnifiedRoutingActionExplainer, {
      metadata: action.metadata,
      objectTypeId: flowObjectTypeId
    });
  }
  const {
    userIds,
    teamIds
  } = action.metadata;
  const users = (userIds || []).map(userId => /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(UserName, {
      id: userId,
      href: null
    })
  }, `user-${userId}`));
  const teams = (teamIds || []).map(teamId => /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(TeamName, {
      id: teamId,
      href: null
    })
  }, `team-${teamId}`));
  return teams.length > 0 ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.rotate-object.explainer.between-teams_cob",
    objectTypeId: flowObjectTypeId,
    options: {
      count: teams.length,
      teamName: teams[0],
      teamNames: /*#__PURE__*/_jsx(FormattedList, {
        children: teams
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.rotate-object.explainer.between-users_cob",
    objectTypeId: flowObjectTypeId,
    options: {
      count: users.length,
      userName: users[0],
      userNames: /*#__PURE__*/_jsx(FormattedList, {
        children: users
      })
    }
  });
}